"use client";
//#region packages/@mantine/core/src/core/styles-api/use-styles/get-class-name/get-selector-class-name/get-selector-class-name.ts
/** Returns class for given selector from library styles (`*.module.css`) */
function getSelectorClassName({ selector, classes, unstyled }) {
	return unstyled ? void 0 : classes[selector];
}
//#endregion
export { getSelectorClassName };

//# sourceMappingURL=get-selector-class-name.mjs.map